export default "__VITE_ASSET__TL2yBNcB__"